import { render } from "./formularioCotizacion.vue?vue&type=template&id=1576a60e"
import script from "./formularioCotizacion.vue?vue&type=script&lang=js"
export * from "./formularioCotizacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__